import flagNo from '../gfx/flag-no.svg';
import flagEn from '../gfx/flag-en.svg';
import flagUk from '../gfx/flag-uk.svg';
import { Stack } from '../components';
import { useCurrentLanguage, Language } from './languageProvider';

export const FlagPicker = () => {

  const { changeLanguage } = useCurrentLanguage();

  return (
    <Stack horizontal horizontalAlign='center'>
      <div style={{ height: '60px', width: '140px', cursor: 'pointer', margin: '0 10px' }} onClick={() => changeLanguage(Language.Norwegian)}>
        <img style={{ maxHeight: 70 }} src={flagNo} />
      </div>
      <div style={{ height: '60px', width: '140px', cursor: 'pointer', margin: '0 10px' }} onClick={() => changeLanguage(Language.English)}>
        <img style={{ maxHeight: 70 }} src={flagEn} />
      </div>
      <div style={{ height: '60px', width: '140px', cursor: 'pointer', margin: '0 10px' }} onClick={() => changeLanguage(Language.Ukrainian)}>
        <img style={{ maxHeight: 70 }} src={flagUk} />
      </div>
    </Stack>
  )
}